import { string, object, array, mixed, boolean } from 'yup';

import { YUP_ERRORS_MESSAGES, VipTaskMarksEnum } from '@shared/constants';

import { validateObjectId } from 'shared/utils';

export const vipTaskValidationSchema = object().shape({
  title: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  imageId: string()
    .test({
      message: YUP_ERRORS_MESSAGES.OBJECT_ID,
      test: validateObjectId,
    })
    .required(YUP_ERRORS_MESSAGES.IMAGE),
  link: string().trim(),
  promoCode: string().trim(),
  ymId: string().trim(),
  casinoName: string().trim(),
  marks: array().of(mixed().oneOf(Object.values(VipTaskMarksEnum)).required(YUP_ERRORS_MESSAGES.REQUIRED)),
  isActive: boolean().required(YUP_ERRORS_MESSAGES.REQUIRED),
});
